/* eslint react/jsx-props-no-spreading: ["off"] */

import React from 'react'
import PropTypes from 'prop-types'
import {
  Button as MaterialButton,
  CircularProgress,
} from '@material-ui/core'
import { IconButton, FloatingButton } from './styles'

export default function Button(props) {
  const {
    buttonType,
    loading,
    startIcon,
    ...rest
  } = props

  let filteredProps = {
    ...rest,
  }

  const renderLoading = () => {
    if (!loading) return startIcon

    return (
      <CircularProgress size="20px" />
    )
  }

  if (buttonType === 'floating') {
    return (
      <FloatingButton {...filteredProps} />
    )
  }

  filteredProps = {
    variant: 'contained',
    ...rest,
  }

  return buttonType === 'icon' ? (
    <IconButton {...filteredProps} />
  ) : (
    <MaterialButton
      {...filteredProps}
      startIcon={renderLoading()}
    />
  )
}

Button.propTypes = {
  buttonType: PropTypes.string,
  loading: PropTypes.bool,
  startIcon: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
    PropTypes.object,
  ]),
}

Button.defaultProps = {
  buttonType: 'button',
  loading: false,
  startIcon: null,
}
